(() => {
  const modal = document.getElementById('exit-confirmation-modal');
  const trigger = document.getElementById('close-configurator');
  const continueButton = modal?.querySelector('[data-exit-modal-close]');
  const leaveButton = modal?.querySelector('[data-exit-modal-confirm]');

  if (!modal || !trigger || !continueButton || !leaveButton) return;

  let previousFocus = trigger;
  let inertSiblings = [];

  // Il tracking e' opzionale: un errore o l'assenza del modulo non devono mai bloccare l'uscita.
  function track(eventName) {
    try {
      window.ThreeDLabConfiguratorTracking?.[eventName]?.();
    } catch (_) {
      // Analytics non disponibile.
    }
  }

  function isOpen() {
    return !modal.classList.contains('hidden');
  }

  function isValidReturnFocus(element) {
    return Boolean(
      element instanceof HTMLElement
      && element.isConnected
      && element !== document.body
      && element !== document.documentElement
      && !modal.contains(element)
    );
  }

  function setBackgroundInert(isInert) {
    if (isInert) {
      inertSiblings = Array.from(modal.parentElement?.children || []).filter(
        (element) => element !== modal && !element.hasAttribute('inert')
      );
      inertSiblings.forEach((element) => element.setAttribute('inert', ''));
      return;
    }

    inertSiblings.forEach((element) => element.removeAttribute('inert'));
    inertSiblings = [];
  }

  function close() {
    if (!isOpen()) return;

    track('exitCancelled');
    setBackgroundInert(false);
    const focusTarget = isValidReturnFocus(previousFocus) ? previousFocus : trigger;
    previousFocus = trigger;
    focusTarget.focus();

    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('inert', '');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function open() {
    if (isOpen()) return;

    previousFocus = isValidReturnFocus(document.activeElement) ? document.activeElement : trigger;
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.removeAttribute('inert');
    trigger.setAttribute('aria-expanded', 'true');
    setBackgroundInert(true);
    continueButton.focus();
  }

  function leave() {
    track('exitConfirmed');

    const productUrl = window.SHOPIFY_CONFIGURATOR?.productUrl;
    const productHandle = window.SHOPIFY_CONFIGURATOR?.productHandle;

    if (productUrl) {
      window.location.assign(productUrl);
    } else if (productHandle) {
      const root = window.Shopify?.routes?.root || '/';
      const localizedRoot = root.endsWith('/') ? root : `${root}/`;
      window.location.assign(`${localizedRoot}products/${productHandle}`);
    } else {
      window.history.back();
    }
  }

  // Click sulla X: registra l'intenzione di uscita una sola volta per apertura del popup.
  window.exitConfigurator = () => {
    if (isOpen()) return;
    track('closeClicked');
    open();
  };

  continueButton.addEventListener('click', close);
  leaveButton.addEventListener('click', leave);
  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      close();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    const firstElement = continueButton;
    const lastElement = leaveButton;

    if (!modal.contains(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? lastElement : firstElement).focus();
    } else if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });
})();
